import { useState, useEffect } from 'react'
import { Marker, Tooltip } from 'react-leaflet'

import icon from './icon'

const Point = ( {
  config
} ) => {
  const [ point, setPoint ] = useState( config.point )
  const [ color, setColor ] = useState( config.color )
  const [ pin, setPin ] = useState( icon( color ) )

  useEffect( () => {
    console.debug( 'update point', point )

    setPoint( ( point ) => {
      return config.point
    } )
  }, [ config.point ] )

  useEffect( () => {
    console.debug( 'update color', config.color )

    setColor( config.color )
  }, [ config.color ] )

  useEffect( () => {
    console.debug( 'update color', config.color )

    setPin( icon( color ) )
  }, [ color ] )

  if ( ! point )
    return null

  return <Marker position={ point } icon={ pin }>
    <Tooltip direction="top" offset={ [ 0, -10 ] } opacity={ 0.7 } permanent>
      { config.label }
    </Tooltip>
  </Marker>
}

export default Point
